import {Injectable} from '@angular/core';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';
import {saveAs} from 'file-saver/FileSaver';
import {ResponseContentType,RequestOptions} from '@angular/http';

@Injectable()
export class BatchService {
  constructor(private http: ApiEvsService) {
  }

  public getRandomPrefix() {
    return this.http.get('/prefix');
  }
  public downloadExcelExample2(url: any) {
    const type = 'application/vnd.ms-excel';
    // @ts-ignore
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi", 'Accept': type })
    });
    return this.http.getFile2(url, options);
  }
  public createBatchStamp(request) {
    return this.http.post('/batches', request);
  }

  public getBatchesList(data_get?: any) {
    return this.http.get('/batches', data_get);
  }

  public getListBatchChild(parent_id, data_get?: any) {
    return this.http.get('/batch/' + parent_id + '/child', data_get);
  }

  public getBatchDetail(id: any) {
    return this.http.get('/batch/' + id);
  }

  public updateBatchStamp(id: any, data?: any) {
    return this.http.put('/batch/' + id, data);
  }

  public confirmPaid(id: any) {
    return this.http.put('/batch/' + id + '/confirm-paid');
  }

  public activeForPrint(id: any, data: any) {
    return this.http.post('/qr-core-aps/batch/' + id + '/active-print', data);
  }

  public setBatchPrinting(id: any, data: any) {
    return this.http.put('/batch/' + id + '/set-printing', data);
  }

  public createDistribution(data: any) {
    return this.http.post('/distribution', data);
  }

  public getDistributionOfBatch(batch_id: any, data?: any) {
    return this.http.get('/qr_aps/distribution/batch/' + batch_id, data);
  }

  public getDistribution(data: any) {
    return this.http.get('/distribution', data);
  }


  public getDistributionDetail(id: any) {
    return this.http.get('/distribution/detail/' + id);
  }

  public getRestores(data: any) {
    return this.http.get('/restores', data);
  }

  public getRestoreDetail(id: any) {
    return this.http.get('/restores/' + id);
  }

  public restoreStamp(body: any) {
    return this.http.post('/restores', body);
  }

  public findStamp(code?: any) {
    return this.http.get('/check/stamp/' + code);
  }

  public ImportStamp(data, file?: any) {
    return this.http.postData('/stamps/map_code', data, file);
  }

  public mapStampHistory() {
    return this.http.get('/stamps/history');
  }

  public getStampImport(option?: any) {
    return this.http.get('/stamps/batch', option);
  }

  public getTokenDownloadBatch(prefix_id: string) {
    return this.http.get('/get-token-download', {prefix_id: prefix_id})
  }

  public getTokenDownloadBatchPP(query) {
    return this.http.getExcel2('/qr_aps/transfer/export', query)
  }

  public saveToFileSystem(response, __type, filename) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');

    if (contentDispositionHeader !== null) {
      const parts: string[] = contentDispositionHeader.split(';');
      //const filename = parts[1].split('=')[1];
      const blob = new Blob([response._body], {type: __type});
      console.log(111, blob)
      saveAs(blob, filename);
    } else {
      // handling download condition if content disposition is empty
      const blob = new Blob([response._body], {type: __type});
      console.log(222, blob)

      saveAs(blob, filename);
    }

  }

  // public export(data, nameFile) {
  //   const link = document.createElement('a');
  //
  //   var binaryData = [];
  //   binaryData.push(data);
  //   link.href = window.URL.createObjectURL(new Blob(binaryData, {type: "application/xlsx"}));
  //   link.download = nameFile;
  //   link.click();
  // }
  public deleteAssignBatch(batch_id, user_id) {
    return this.http.delete('/batch/' + batch_id + '/unassign/' + user_id)
  }

  public assignBatch(batch_id, user_id) {
    return this.http.post('/batch/' + batch_id + '/assign/' + user_id)
  }

  public getBatchesAssign(user_id, data_get?: any) {
    return this.http.get('/batch/assign/' + user_id, data_get);
  }

  public detailStamp(id) {
    return this.http.get(`/qr_aps/mobile/scan/decode?code=${id}`);
  }

  public listEcommerce(id) {
    return this.http.get(`/qr-core-aps/batch/${id}/product_link?page=0&pageSize=100`);
  }

  public changeSetting(id, productLinkId, body) {
    return this.http.put(`/qr-core-aps/batch/${id}/product_link/${productLinkId}`, body);
  }

  /**Tuanba: 11/10/2022: Tối ưu prefix **/
  public checkDuplicatePrefix(prefix) {
    return this.http.get(`/qr-core-aps/prefix/duplication?prefix=${prefix}`);
  }

  public autoGeneratePrefix() {
    return this.http.get(`/qr-core-aps/prefix/random`);
  }

  public getPrefix(data) {
    return this.http.get(`/qr-core-aps/prefix`, data);
  }

  public getListStamp(id: any) {
    return this.http.get(`/qr-core-aps/batch/batch_action/${id}/batch_log/list_id_start_equal_id_end`);
  }

  /**Tuanba: 27-2-2024 Sửa lại phần tải về lô tem**/
  public getPasswordDownloadBatch(batchID: any) {
    return this.http.post(`/qr-core-aps/batch/${batchID}/send_mail_password_download_batch`)
  }
  public downloadBatchWithPassword(batchID: any, body: any) {
    return this.http.post(`/qr-core-aps/batch/${batchID}/send_mail_stamp_in_batch`, body)
  }
  deleteBatchStamp(id: number) {
    return this.http.delete(`/qr-core-aps/batch/${id}`);
  }



}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/batch.service.ts